export class apiURL {
    public static urlTemp: string = 'https://apisandbox.suprem.exchange';
    public static url: string = 'https://apisandbox.suprem.exchange';
    // public static url: string = 'https://api.imibanking.com';
}